import React, { Component } from 'react';
import { connect } from 'react-redux';

import Spinner from './Spinner';

interface SpinnerContainerProps {
  fetching: number
}

class SpinnerContainer extends Component<SpinnerContainerProps> {

  render() {
    return (
      this.props.fetching ? <Spinner /> : null
    );
  };
};

const mapStateToProps = (state: any) => {
  return {
    fetching: state.fetching.loading
  };
};

export default connect(mapStateToProps)(SpinnerContainer);